import React, { Component } from "react";
import ReactSimpleKeyboard from "react-simple-keyboard";
import EventService from "@shared/services/EventService";
import "@app/stylesV2/components/Keyboard/NumericalKeyboard.scss"
import "@app/stylesV2/components/Keyboard/ArabicKeyboard.scss"
import "@app/stylesV2/components/Keyboard/AlphaNumericKeyboard.scss"

export default class Keyboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            layoutName: "default",
            themeName: "number",
        };
    }

    componentDidMount() {
        if (this.props.layoutName) {
            this.setState({
                layoutName: this.props.layoutName,
                themeName: this.props.themeName?this.props.themeName:"number"
            });
        }
        if(this.props?.value){
            this.keyboard?.setInput(this.props?.value);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.layoutName && this.props.layoutName != prevProps.layoutName) {
            this.setState({
                layoutName: this.props.layoutName
            });
        }
        if(this.props?.value){
            this.keyboard.setInput(this.props?.value);
        }
    }

    onKeyPress = button => {
        if (button === "{shift}" || button === "{lock}") {
            this.handleShift();
        } else if (button === "{numbers}" || button === "{abc}") {
            this.handleNumbers();
        } else if (button === "{backspace}" || button === "{bigbackspace}") {
            EventService.publish(`keypad.backspace.${this.props.inputContext}`);
            EventService.publish("keypad.blur", false);
        } else if (button === "{OK}" || button === "{ok}") {
            EventService.publish(`keypad.ok.${this.props.inputContext}`);
            EventService.publish("keypad.blur", true);
        } else {
            if (button === "{space}") {
                button = " ";
            }
            if (button === "{tab}") {
                button = "    ";
            }
            EventService.publish(`keypad.input.${this.props.inputContext}`, button);
            EventService.publish("keypad.blur", false);
        }
    };

    handleNumbers = () => {
        let { layoutName } = this.state;
        EventService.publish("keypad.blur", false);
        this.setState({ layoutName: layoutName !== "numbers" ? "numbers" : "default" });
    };

    handleShift = () => {
        let { layoutName } = this.state;
        EventService.publish("keypad.blur", false);
        this.setState({ layoutName: layoutName === "default" ? "shift" : "default" });
    };

    getLayout = () => {
        let lang = this.props.virtualKeyboardLang || "en";
        const layoutMap = {
            en: {
                default: [
                    "q w e r t y u i o p",
                    "a s d f g h j k l",
                    "{shift} z x c v b n m {backspace}",
                    '{numbers} @ {space} - {tab}',
                    "{OK}"
                ],
                shift: [
                    "Q W E R T Y U I O P",
                    "A S D F G H J K L",
                    "{shift} Z X C V B N M {backspace}",
                    "{numbers} @ {space} - {tab}",
                    "{OK}"
                ],
                numbers: ['1 2 3 .', "4 5 6 {backspace}", "7 8 9 0", "{OK} {abc}"],
                numbers2: ['1 2 3 .', "4 5 6 {backspace}", "7 8 9 0", "{OK}"],
                numbers3: ['1 2 3', "4 5 6", "7 8 9", "0 {backspace}", "{OK}"],
                numbersPin: ["1 2 3", "4 5 6", "7 8 9", "0 {bigbackspace}"]
            },
            en2: {
                default: [
                    "q w e r t y u i o p",
                    "@ a s d f g h j k l .",
                    "{shift} z x c v b n m {bigbackspace}",
                    '{numbers} {space} {tab}',
                    "{OK}"
                ],
                shift: [
                    "Q W E R T Y U I O P",
                    "@ A S D F G H J K L .",
                    "{shift} Z X C V B N M {bigbackspace}",
                    "{numbers} {space} {tab}",
                    "{OK}"
                ],
                numbers: ['1 2 3', "4 5 6", "7 8 9", "{abc} 0 {backspace}", "{ok}"],
                numbers2: ['1 2 3 .', "4 5 6 {backspace}", "7 8 9 0", "{OK}"],
                numbers3: ['1 2 3', "4 5 6", "7 8 9", ". 0 {backspace}", "{OK}"],
                numbersPin: ["1 2 3", "4 5 6", "7 8 9", "0 {backspace}", "{OK}"]
            },
            ar: {
                default: [
                    "ذ 1 2 3 4 5 6 7 8 9 0",
                    "ض ص ث ق ف غ ع ه خ ح ج",
                    "ش س ي ب ل ا ت ن م ك ط",
                    "ئ ء ؤ ر لا ى ة و ز ظ د",
                    "{shift} {space} {backspace}",
                    "{OK}"
                ],
                shift: [
                    "ذ 1 2 3 4 5 6 7 8 9 0",
                    "ض ص ث ق ف غ ع ه خ ح ج",
                    "ش س ي ً لأ أ ت آ لآ ك ط",
                    "ئ ء ؤ ر لإ إ ة و ز ظ ذ",
                    "{shift} {space} {backspace}",
                    "{OK}"
                ],
                numbers: [
                    "ذ 1 2 3 4 5 6 7 8 9 0",
                    "ض ص ث ق ف غ ع ه خ ح ج",
                    "ش س ي ب ل ا ت ن م ك ط",
                    "ئ ء ؤ ر لا ى ة و ز ظ د",
                    "- {space} {backspace}",
                    "{OK}"
                ]
            }
        };
        return layoutMap[lang];
    };
    
    getTheme = () => {
        let{themeName }=this.props
        const defaultTheme=[
                    {
                        class: "hg-red",
                        buttons: "{OK}"
                    },
                    {
                        class: "space-button",
                        buttons: "{space}"
                    },
                    {
                        class: "hg-highlight2",
                        buttons: '1 2 3 4 5 6 7 8 9 0 {abc} {backspace} . , / _ "'
                    },
                    {
                        class: "hlg-top",
                        buttons: '. "'
                    },
                    {
                        class: "hlg-bottom",
                        buttons: "/ -"
                    },
                    {
                        class: "hlg-mid",
                        buttons: ", _"
                    },
                    {
                        class: "alpha-button",
                        buttons:
                            "- @ q w e r t y u i o p a s d f g h j k l  z x c v b n m  Q W E R T Y U I O P A S D F G H J K L Z X C V B N M لإ آ ئ ء ؤ ر لا ى ة و ز ظ ش س ي ب ل ا ت ن م ك ط ض ص ث ق ف غ ع ه خ ح ج د ذ لأ أ ً إ لآ"
                    },
                    {
                        class: "shift-button",
                        buttons: "{backspace} {shift} {tab} {numbers}"
                    },
                    {
                        class: "big-backspace",
                        buttons: "{bigbackspace}"
                    }
                ]
        const alphaTheme=[
                    {
                        class: "hg-ok-button",
                        buttons: "{OK}"
                    },
                    {
                        class: "vertical",
                        buttons: "{ok}"
                    },
                    {
                        class: "alpha-button space-button",
                        buttons: "{space}"
                    },
                    {
                        class: "hg-highlight2",
                        buttons: '1 2 3 4 5 6 7 8 9 0 {abc} {backspace} , / _ "'
                    },
                    {
                        class: "hlg-top",
                        buttons: '. "'
                    },
                    {
                        class: "hlg-bottom",
                        buttons: "/ -"
                    },
                    {
                        class: "hlg-mid",
                        buttons: ", _"
                    },
                    {
                        class: "alpha-button",
                        buttons:
                            "- @ . q w e r t y u i o p a s d f g h j k l  z x c v b n m  Q W E R T Y U I O P A S D F G H J K L Z X C V B N M لإ آ ئ ء ؤ ر لا ى ة و ز ظ ش س ي ب ل ا ت ن م ك ط ض ص ث ق ف غ ع ه خ ح ج د ذ لأ أ ً إ لآ"
                    },
                    {
                        class: "alpha-button shift-button",
                        buttons: "{bigbackspace} {shift} {tab} {numbers}"
                    }
                ]
        const arabicTheme=[
                    {
                        class: "vertical",
                        buttons: "{OK}"
                    },
                    {
                        class: "alpha-button space-button",
                        buttons: "{space}"
                    },
                    {
                        class: "hlg-bottom",
                        buttons: "/ -"
                    },
                    {
                        class: "hlg-mid",
                        buttons: ", _"
                    },
                    {
                        class: "alpha-button",
                        buttons:
                            "1 2 3 4 5 6 7 8 9 0 . - @ . q w e r t y u i o p a s d f g h j k l  z x c v b n m  Q W E R T Y U I O P A S D F G H J K L Z X C V B N M لإ آ ئ ء ؤ ر لا ى ة و ز ظ ش س ي ب ل ا ت ن م ك ط ض ص ث ق ف غ ع ه خ ح ج د ذ لأ أ ً إ لآ"
                    },
                    {
                        class: "alpha-button shift-button",
                        buttons: "{backspace} {shift} {tab} {numbers}"
                    }
                ]
        const numberTheme=[
                    {
                        class: "hg-highlight2 vertical",
                        buttons: "{OK}"
                    },
                    {
                        class: "hg-highlight2",
                        buttons: '1 2 3 4 5 6 7 8 9 0 .'
                    },
                    {
                        class: "hg-highlight2 back-space",
                        buttons: "{backspace}"
                    }
                ]
        switch (themeName) {
            case "numberic":
                return numberTheme;
            case "alphanumeric":
                return alphaTheme;
            case "arabic":
                return arabicTheme;
            default:
                return defaultTheme;
        }
    }


    render() {
        return (
            <ReactSimpleKeyboard
                className={`simple-keyboard`}
                layout={this.getLayout()}
                layoutName={this.state.layoutName}
                theme={`hg-theme-default ${this.props.themeName} KioskThem ${this.props.virtualKeyboardLang === "ar" ? "arabic-keyboard" : ""}`}
                mergeDisplay={true}
                buttonTheme={this.getTheme()}
                display={{
                    "{numbers}": "123",
                    "{tab}": "⇥",
                    "{backspace}": "⌫",
                    "{capslock}": "caps lock ⇪",
                    "{abc}": "ABC",
                    "{shift}": "⇧",
                    ".": "	&#46;",
                    ",": "	&#44;",
                    "{space}": "SPACEBAR",
                    "{bigbackspace}":"⌫",
                    "{OK}":"OK",
                    "{ok}":"OK"
                }}
                onKeyPress={button => this.onKeyPress(button)}
                onChange={this.props?.handleInputChange ? (input)=>this.props?.handleInputChange(input):""}
                keyboardRef={r => (this.keyboard = r)}
            />
        );
    }
}
